import { dayLabel, fromKey, weekdayShort } from '../../lib/mealPlan'

// The Plan tab's week at a glance on the phone: seven chips, weekday over
// date, that stay under the tabs while the agenda scrolls. Today is the lime
// chip, a dot is a day with a meal, days gone by are dimmed; a tap goes to the
// day (MealPlanTab scrolls to it and outlines it).
export function DayStrip({ days, todayKey, counts, onPick }: {
  days: string[]
  todayKey: string
  /** Meals per day key. */
  counts: Record<string, number>
  onPick: (day: string) => void
}) {
  return (
    <div className="ml-strip" role="group" aria-label="Days of the week">
      {days.map(d => {
        const n = counts[d] ?? 0
        const today = d === todayKey
        return (
          <button key={d} type="button" aria-current={today ? 'date' : undefined}
            aria-label={n ? `${dayLabel(d)}, ${n} ${n === 1 ? 'meal' : 'meals'}` : dayLabel(d)}
            className={['ml-strip__day', today && 'is-today', d < todayKey && 'is-past', n > 0 && 'has-meals'].filter(Boolean).join(' ')}
            onClick={() => onPick(d)}>
            <span className="ml-strip__dow">{weekdayShort(d)}</span>
            <span className="ml-strip__num ml-num">{fromKey(d).getDate()}</span>
            <span className="ml-strip__dot" aria-hidden="true" />
          </button>
        )
      })}
    </div>
  )
}
